import { InjectionToken } from '@angular/core';

export const DEVSTROUPE_CONFIG = new InjectionToken<any>('DEVSTROUPE_APP_CONFIG');
